import { addMonths, addYears } from 'date-fns';

import { OperatingHours } from '../../../services/types/contractDetailsResponse';

export const convertSAPDateToDate = (date: string) => {
  const [year, month, day] = date.split('-');

  return new Date(Number(year), Number(month) - 1, Number(day));
};

export const linearRegression = (y: number[], x: number[]) => {
  const lr: { slope: number; intercept: number; r2: number } = {
    slope: 0,
    intercept: 0,
    r2: 0,
  };

  const n = y.length;
  let sumX = 0;
  let sumY = 0;
  let sumXY = 0;
  let sumXX = 0;
  let sumYY = 0;

  for (let i = 0; i < y.length; i += 1) {
    sumX += x[i];
    sumY += y[i];
    sumXY += x[i] * y[i];
    sumXX += x[i] * x[i];
    sumYY += y[i] * y[i];
  }

  lr.slope = (n * sumXY - sumX * sumY) / (n * sumXX - sumX * sumX);
  lr.intercept = (sumY - lr.slope * sumX) / n;
  lr.r2 =
    ((n * sumXY - sumX * sumY) /
      Math.sqrt((n * sumXX - sumX * sumX) * (n * sumYY - sumY * sumY))) **
    2;

  return lr;
};

export const mapOperatingHours = (
  operatingHoursTmp: OperatingHours[],
  begin: Date,
  end: Date,
) => {
  if (operatingHoursTmp.length <= 0) {
    return [];
  }
  let result = operatingHoursTmp.map((e) => {
    return { date: convertSAPDateToDate(e.date), h: e.value / 3600 };
  });

  result.sort((a, b) => {
    if (a.date > b.date) {
      return 1;
    }
    if (a.date < b.date) {
      return -1;
    }
    return 0;
  });

  const firstMeasureInContract = result[0];

  result = result.filter((res) => res.date >= begin && res.date <= end);

  const realresult: { date: Date; h: number }[] = [];

  for (const res of result) {
    const monthIndex = realresult.findIndex(
      (rr) =>
        rr.date.getMonth() === res.date.getMonth() &&
        rr.date.getFullYear() === res.date.getFullYear(),
    );
    if (monthIndex >= 0) {
      if (res.date.getDate() >= realresult[monthIndex].date.getDate()) {
        realresult[monthIndex] = res;
      }
    } else {
      realresult.push(res);
    }
  }

  if (
    firstMeasureInContract.date >= begin &&
    firstMeasureInContract.date <= end
  ) {
    realresult.push(firstMeasureInContract);
  }

  realresult.sort((a, b) => {
    if (a.date > b.date) {
      return 1;
    }
    if (a.date < b.date) {
      return -1;
    }
    return 0;
  });

  return realresult.map((e) => {
    return {
      h: Math.round(e.h - firstMeasureInContract.h),
      date: e.date.valueOf(),
    };
  });
};

export const getTicks = (begin: Date, end: Date) => {
  const result = [];
  let currentDate = begin;
  while (currentDate < end) {
    result.push(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1));
    currentDate = addMonths(currentDate, 1);
  }
  return result.map((res) => res.valueOf());
};

export const getFilterBegin = (contractBegin: Date) => {
  const oneYearAgo = addYears(new Date(), -1);
  if (contractBegin < oneYearAgo) {
    return oneYearAgo;
  }
  return contractBegin;
};

export const getFilterEnd = (contractEnd: Date, prolongedEnd: boolean) => {
  const oneYearAhead = addYears(new Date(), 1);
  if (
    (contractEnd > new Date() && contractEnd > oneYearAhead) ||
    prolongedEnd
  ) {
    return oneYearAhead;
  }
  return contractEnd;
};
